var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 542.14814 542.14811",
    id: "logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "g24543",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 270.93333,541.86666 210.46639,420.93282 c 34.80176,-38.28506 56.13043,-98.51647 55.69741,-149.99948 -0.44852,-53.32605 -15.48176,-97.96634 -55.74445,-149.734 L 270.93331,0.30973758 331.51582,121.16509 c -30.41232,36.38917 -54.87887,86.07409 -55.81298,149.76824 -0.78124,53.27077 22.51173,112.28529 55.69164,150.01102 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 270.93333,541.86666 210.46639,420.93282 c 34.80176,-38.28506 56.13043,-98.51647 55.69741,-149.99948 -0.44852,-53.32605 -15.48176,-97.96634 -55.74445,-149.734 L 270.93331,0.30973758 331.51582,121.16509 c -30.41232,36.38917 -54.87887,86.07409 -55.81298,149.76824 -0.78124,53.27077 22.51173,112.28529 55.69164,150.01102 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 149.49507,297.52198 -13.30388,-26.59764 13.22731,-26.4446 13.22731,-26.44457 3.50841,3.80616 c 9.81458,10.64755 26.56546,22.57137 42.28729,30.10141 29.41738,14.08962 60.05428,17.94142 91.58917,11.51504 16.37758,-3.33756 36.22292,-11.53282 50.54992,-20.87491 7.82169,-5.10024 20.0955,-15.20177 25.20188,-20.74154 l 3.5084,-3.80616 13.22731,26.44457 13.2273,26.4446 -13.17629,26.34258 -13.17627,26.34261 -7.88525,-7.60828 C 322.7576,268.96346 248.21646,261.89636 191.7758,298.96121 c -8.73635,5.73722 -21.26173,16.13246 -25.71339,21.34047 l -3.26348,3.81794 z"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5c489cffccaef2b756e17513efa59b98.svg";
export { ForwardRef as ReactComponent };